var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#818181",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.27022 6.74C1.14022 4.788 3.89222 0 10.0002 0C16.1102 0 18.8612 4.788 19.7302 6.74C19.9074 7.13643 19.999 7.56578 19.999 8C19.999 8.43422 19.9074 8.86357 19.7302 9.26C18.8612 11.212 16.1102 16 10.0002 16C3.89222 16 1.14022 11.212 0.27022 9.26C0.0930425 8.86357 0.00146484 8.43422 0.00146484 8C0.00146484 7.56578 0.0930425 7.13643 0.27022 6.74ZM10.0002 12C11.0611 12 12.0785 11.5786 12.8286 10.8284C13.5788 10.0783 14.0002 9.06087 14.0002 8C14.0002 6.93913 13.5788 5.92172 12.8286 5.17157C12.0785 4.42143 11.0611 4 10.0002 4C8.93935 4 7.92194 4.42143 7.17179 5.17157C6.42165 5.92172 6.00022 6.93913 6.00022 8C6.00022 9.06087 6.42165 10.0783 7.17179 10.8284C7.92194 11.5786 8.93935 12 10.0002 12Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#818181",
    d: "M8.5003 8C8.74009 8.00001 8.9764 7.94253 9.1894 7.83238C9.40241 7.72223 9.58589 7.56262 9.72449 7.36692C9.86308 7.17123 9.95273 6.94516 9.98593 6.70767C10.0191 6.47018 9.99491 6.2282 9.9153 6.002L10.0003 6C10.3995 5.99996 10.7896 6.11938 11.1203 6.34289C11.4511 6.56641 11.7074 6.88378 11.8562 7.25418C12.0051 7.62458 12.0397 8.03105 11.9556 8.42128C11.8715 8.81152 11.6726 9.16766 11.3844 9.44389C11.0962 9.72011 10.7319 9.90377 10.3385 9.97123C9.94504 10.0387 9.5404 9.98688 9.17665 9.82244C8.8129 9.658 8.50668 9.38848 8.29739 9.04855C8.0881 8.70862 7.98533 8.31383 8.0023 7.915C8.1623 7.97129 8.33068 8.00003 8.5003 8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eye-open.7f5f4f28f3487dc8935b3da8f781681c.svg";
export { ForwardRef as ReactComponent };